/**
 * NativeBridgeTokenProvider — Android token provider.
 * Delegates to AuthNativeBridge → RN → Kotlin AuthModule.
 */

import type { OAuthProviderConfig } from '../web/types'
import type { TokenProvider } from '../TokenProvider'

export class NativeBridgeTokenProvider implements TokenProvider {
    private providerConfig: OAuthProviderConfig | null = null

    public async getAccessToken (): Promise<string> {
        const { authNativeBridge } = await import('./AuthNativeBridge')
        const response = await authNativeBridge.getAccessToken()
        if (!response.access_token) throw new Error('No access token from native bridge')
        return response.access_token
    }

    public async isAuthenticated (): Promise<boolean> {
        // RN shell verified auth before loading WebView — trust it
        return true
    }

    public storeTokens (): void {
        // No-op — native shell manages storage
    }

    public getProviderConfig (): OAuthProviderConfig | null {
        return this.providerConfig
    }

    public setProviderConfig (config: OAuthProviderConfig): void {
        this.providerConfig = config
    }

    public async clear (): Promise<void> {
        const { authNativeBridge } = await import('./AuthNativeBridge')
        await authNativeBridge.logout()
        this.providerConfig = null
    }
}
